<template id="map-template">
  <div class="homeview-realtime-data">
    <div class="device-circle-chart">
      <div
        class="task-item"
        v-bind:class="{
          item1: index == 0,
          item2: index == 1,
          item3: index == 2,
        }"
        v-for="(item, index) in equipmentList"
        :key="index"
      >
        <div class="task-icon-wrapper">
          <span
            v-bind:class="{
              font1: index == 0,
              font2: index == 1,
              font3: index == 2,
            }"
            >{{ item.Count }}</span
          >
          <div class="task-icon"></div>
        </div>
        <div class="task-status">{{ item.Name }}</div>
      </div>
    </div>
    <div class="bar-chart">
      <BarEchart4
        :chartData="deviceData"
      ></BarEchart4>
    </div>
  </div>
</template>

<script>
import { listEquipment } from "@/api/src/equipment";
import LedApis from "@/plugins/led/src/apis";
import EquipmentApis from "@/plugins/broadcast/src/apis";
import WifiApis from "@/plugins/wifi/src/apis";
import utils from "@/utils"

export default {
  name: "HomeViewDeviceData",
  componentName: "HomeViewDeviceData",
  components: {},
  props: {},
  data() {
    return {
      timer: null,
      equipmentList: [
        { Name: "设备总数", Count: 0 },
        { Name: "故障", Count: 0 },
        { Name: "故障率", Count: 0 },
      ],
      total: 0,
      deviceData: { 
        name: ['LED','广播','Wifi','SOS','摄像头'], 
        count1: [1,1,1,1,1], //故障数
        count2: [10,10,10,10,10]  //在线数
      },
      tempArr: {
        name: [], 
        count1: [], 
        count2: []  
      }
    };
  },
  methods: {
    // LED
    getLedData(){
      return new LedApis.TranResourcesApi().GetItemPagingList({ Ledtype: -1 }).then(res => {
        res = res.data.Data;
        this.total += res.BaseSearch.TotalCount;
        this.tempArr.name.push('LED');
        this.tempArr.count1.push(res.PageContents.filter(item => {
          return item.STATE_EQT == 0 || item.STATE_EQT == null
        }).length);
        this.tempArr.count2.push(res.PageContents.filter(item => {
          return item.STATE_EQT == 1
        }).length);
      })
      return '';
    },
    // 广播
    getBroadcastData(){
      return listEquipment({ categoryCode: "broadcast", pageSize: 10000 }).then(res => {
        this.total += res.total;
        this.tempArr.name.push('广播');
        this.tempArr.count1.push(res.rows.filter(item => {
          return item.onlineStatus == "2" || item.onlineStatus == null
        }).length);
        this.tempArr.count2.push(res.rows.filter(item => {
          return item.onlineStatus == "1"
        }).length);
      });
      // return new EquipmentApis.TranResourcesApi().GetEquipmentPagingList({ EquipmentType: "Broadcast", PageIndex:1, PageSize:10000 }).then(res => {
      //   res = res.data.Data;
      //   this.total += res.BaseSearch.TotalCount;
      //   this.tempArr.name.push('广播');
      //   this.tempArr.count1.push(res.PageContents.filter(item => {
      //     return item.IsOnline == false || item.IsOnline == null
      //   }).length);
      //   this.tempArr.count2.push(res.PageContents.filter(item => {
      //     return item.IsOnline == true
      //   }).length);
      // });
    },
    // 摄像头
    getMonitorData(){
      return listEquipment({ categoryCode: "monitor", pageSize: 10000 }).then(res => {
        this.total += res.total;
        this.tempArr.name.push('摄像头');
        this.tempArr.count1.push(res.rows.filter(item => {
          return item.onlineStatus == "2" || item.onlineStatus == null
        }).length);
        this.tempArr.count2.push(res.rows.filter(item => {
          return item.onlineStatus == "1"
        }).length);
      });
    },
    // wifi
    getWifiData(){
      // return new WifiApis.TranResourcesApi().GetDeviceListPaging({ PageIndex:1, PageSize:10000 }).then(res => {
      //   res = res.data.Data;
      //   this.total += res.BaseSearch.TotalCount;
      //   this.tempArr.name.push('wifi');
      //   this.tempArr.count1.push(res.PageContents.filter(item => {
      //     return item.Status == 0 || item.Status == null
      //   }).length);
      //   this.tempArr.count2.push(res.PageContents.filter(item => {
      //     return item.Status == 1
      //   }).length);
      // });
      return listEquipment({ categoryCode: "wifi", pageSize: 10000 }).then(res => {
        this.total += res.total;
        this.tempArr.name.push('wifi');
        this.tempArr.count1.push(res.rows.filter(item => {
          return item.onlineStatus == "2" || item.onlineStatus == null
        }).length);
        this.tempArr.count2.push(res.rows.filter(item => {
          return item.onlineStatus == "1"
        }).length);
      });
    },
    // sos
    getSOSData(){
       return listEquipment({ categoryCode: "sos", pageSize: 10000 }).then(res => {
        this.total += res.total;
        this.tempArr.name.push('sos');
        this.tempArr.count1.push(res.rows.filter(item => {
          return item.onlineStatus == "2" || item.onlineStatus == null
        }).length);
        this.tempArr.count2.push(res.rows.filter(item => {
          return item.onlineStatus == "1"
        }).length);
      });
      // return new EquipmentApis.TranResourcesApi().GetEquipmentPagingList({ DeviceType: "SubSystem.Monitor.EquipmentType.Sos", PageIndex:1, PageSize:10000 }).then(res => {
      //   res = res.data.Data;
      //   this.total += res.BaseSearch.TotalCount;
      //   this.tempArr.name.push('sos');
      //   this.tempArr.count1.push(res.PageContents.filter(item => {
      //     return item.IsOnline == false || item.IsOnline == null
      //   }).length);
      //   this.tempArr.count2.push(res.PageContents.filter(item => {
      //     return item.IsOnline == true
      //   }).length);
      // });
    },
    getData() {
      this.equipmentList = [];
      this.total = 0;
      this.tempArr = { name: [], count1: [], count2: []};
      return utils.waitAll([
        // () => this.getLedData(), 
        () => this.getBroadcastData(),
        () => this.getWifiData(), 
        // () => this.getSOSData(),
        () => this.getMonitorData(),
      ]).then(() => {
        this.deviceData = this.tempArr;
        let faultSum = 0;
        this.deviceData.count1.forEach(item => {
          faultSum += item;
        });
        this.equipmentList = [
          { 
            Name: "设备总数",
            Count: this.total || 0,
          },
          {
            Name: "故障",
            Count: faultSum || 0,
          },
          {
            Name: "故障率",
            Count: ((faultSum/this.total)*100).toFixed(2) + "%" || 0,
          },
        ];
      });
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.getData();
    }, window.$config.app.intervalTime || 300000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>